import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { OnyxEvent } from '../models/event';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import { OnyxSummaryEvent } from '../models/event.summary';
import { Page } from '../../shared/models/page';
import { EventSearchParameters } from '../models/event-search-params';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { BulkUploadResponse } from '../models/bulk-upload-response';

@Injectable()
export class EventHttpService {
  private eventsGetUrl: string = this.environment.baseUrl + '/api/events';
  private eventSearchUrl: string = this.environment.baseUrl + '/api/events/search';
  private eventsAddUrl: string = this.environment.baseUrl + '/api/events';
  private eventsUpdateUrl: string = this.environment.baseUrl + '/api/events';
  private eventsBulkUploadUrl: string = this.environment.baseUrl + '/api/events/bulkUpload';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  search(searchParameters: EventSearchParameters): Observable<Page<OnyxSummaryEvent>> {
    return this.http.post(this.eventSearchUrl, JSON.stringify(searchParameters), this.jsonOptions)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  get(eventId: number): Observable<OnyxEvent> {
    return this.http.get(`${this.eventsGetUrl}/${eventId}`)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  add(newRec: OnyxEvent): Observable<OnyxEvent> {
    return this.http.post(this.eventsAddUrl, JSON.stringify(newRec.toJS()), this.jsonOptions)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  update(updatedRec: OnyxEvent): Observable<OnyxEvent> {
    return this.http.put(this.eventsUpdateUrl, JSON.stringify(updatedRec.toJS()), this.jsonOptions)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  delete(eventId: number): Observable<any> {
    return this.http.delete(`${this.eventsGetUrl}/${eventId}`)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  importEventsViaCsv(file: File): Observable<BulkUploadResponse> {
    let formData: FormData =  new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventsBulkUploadUrl}`, formData)
      .map(response => response.json()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  downloadInvalidEventsCsv(fileId: number): Observable<any> {
    this.http.get(`${this.eventsBulkUploadUrl}` + `/` + fileId);
    return Observable.of(null);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event.http.service.ts